import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Input } from 'components/fields'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'

@form({
  form: 'change-ajpe-goal'
})
class AjPEventChangeAim extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    modal: PropTypes.func.isRequired,
    changeAjParticipantEventGoal: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
  }
  static defaultProps = {
    data: {}
  }

  render() {
    const { handleSubmit, data } = this.props

    return (
      <form
        onSubmit={handleSubmit(fields =>
          this.props.changeAjParticipantEventGoal(
            get(data, 'participantEvent.id'),
            fields
          )
        )}
      >
        <Input name="aim" label="New goal" intkKey="label.new_goal" />
        <div className="row">
          <div className="col-xs-6">
            <Button
              type="button"
              secondary
              onClick={() => this.props.modal(null)}
              intlKey="button.close"
            >
              Close
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              onClick={() => this.props.modal(null)}
              intlKey="button.change"
            >
              Change
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default AjPEventChangeAim
